import ModuleMixin from '@/Mixins/ModuleMixin'

export default {
    mixins: [
        ModuleMixin
    ],

    data() {
        return {
            name: 'module.shippingQuote',
            quote: [],
            quoting: false
        }
    },

    methods: {
        quoteByOrder(order, postcode_to) {
            this.quoting = true

            return axios({
                method: 'post',
                url: route('api.quotations.quoteByOrder', order),
                data: {postcode_to: String(postcode_to)}
            })
            .then(response => {
                if(response.data.success) {
                    this.$set(this, 'quote', response.data.data)
                    return this.quote
                } else {
                    return Promise.reject(response.data,message)
                }
            })
            .catch(error => {
                this.$alert(Object.values(error.response.data.errors)[0][0], 'Error!', 'error')

                return Promise.reject(Object.values(error.response.data.errors)[0][0])
            })
            .finally(() => this.quoting = false)
        }
    }
}